<template>
  <DialogTutorialBase :delay-button="600" v-bind="props">
    <template #title> Fais-toi 10 minutes / jour ⚡️ </template>
    <DomFade :delay="10">
      C’est le temps qu’il faut passer dans l’<strong>app Nomad</strong> chaque
      jour pour gagner au moins <strong>3 points de moyenne</strong> 😍
    </DomFade>
    <DomFade :delay="120">
      ☀️ Tips :
      <strong>
        mets-toi un rappel dans ton tel tous les soirs pour faire ta session à
        20h45
      </strong>
      , on s’occupe du reste !
    </DomFade>
  </DialogTutorialBase>
</template>
<script lang="ts" setup>
interface Props {
  onNext: Function;
}

const props = defineProps({
  onNext: { type: Function }
});
</script>
<style lang="scss" scoped></style>
